import {
  initialState,
  Actions,
  State,
  RESTORE_MODULES,
  RESTORE_MODULES_SUCCESS,
  RESTORE_MODULES_ERROR,
  RESET_RESTORE_MODULES,
} from "../../types/module/restore-modules";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case RESTORE_MODULES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case RESTORE_MODULES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case RESTORE_MODULES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_RESTORE_MODULES:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
